import { IAjax } from 'lib/Ajax';
import { ImageData } from 'data/models/Image';
import { SaveImageRequest } from 'data/models/SaveImageRequest';

export class CropSelection {
    constructor(
        public x1 : number,
        public y1 : number,
        public x2 : number,
        public y2 : number
    ) { }

    toArray() : number[] {
        return [this.x1, this.y1, this.x2, this.y2];
    }
}

export interface CropImageParams {
    imageUrl : string;
    imageHeight : number;
    imageWidth : number;
    initialSelection : CropSelection | null;
    minSize : number;
    saveUrl : string;
    onComplete : (data : ImageData) => void;
    onCloseModal : () => void;
}

export function CropImage(ajax : IAjax, { imageUrl, imageHeight, imageWidth, initialSelection, minSize, saveUrl, onComplete, onCloseModal } : CropImageParams) {
    let saveImageRequest = new SaveImageRequest({ RawUrl: imageUrl }),
        _initialSelection : CropSelection;

        if (initialSelection) {
            _initialSelection = initialSelection;
        } else {
            // if initial selection is not provided, set initial selection to be maximum possible square in middle of image
            let minDimension = Math.min(imageHeight, imageWidth),
                xOffset = (imageWidth - minDimension) / 2,
                yOffset = (imageHeight - minDimension) / 2;
            _initialSelection = new CropSelection(xOffset, yOffset, imageWidth - xOffset, imageHeight - yOffset);
        }

    return {
        ImageUrl: imageUrl,
        InitialSelection: _initialSelection,
        MinSize: minSize,
        OnJCropSelect: OnJCropSelect,
        SaveSelection: SaveSelection,
        Cancel: Cancel
    };

    function OnJCropSelect(coords : JCropCoordinates) {
        SaveImageRequest.update(saveImageRequest, {
            CropX1: coords.x,
            CropY1: coords.y,
            CropX2: coords.x2,
            CropY2: coords.y2
        });
    }

    function SaveSelection() {
        ajax.Url<SaveImageRequest, ImageData>(saveUrl).Post(saveImageRequest)
        .then(data => {
            onComplete(data);
            onCloseModal();
        });
    }

    function Cancel() {
        onCloseModal();
    }
}
export type CropImage = ReturnType<typeof CropImage>;


// WEBPACK FOOTER //
// ./apps/portcall/cropimage/model.ts